import { getAllPlanning } from '@/api/dispo';
import moment from 'moment';

export default async function getDisponibilite(ligneCommande, dateDebut, dateFin) {
  const debut = dateDebut ?? moment(new Date()).toDate();
  const fin = dateFin ?? moment(new Date()).toDate();
  const disponibilite = (await getAllPlanning([ligneCommande.produitId],
    debut, fin)).data.result[ligneCommande.produitId][0];

  return disponibilite;
}
